import axios from "./productInstance"

export default async () => {
  try {
    const response: any = await axios(`/products/sync/result`)
    return response.data
  } catch (error) {
    return null
  }
}
